// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectChatTasks_container__1CHCH","hidden":"ProjectChatTasks_hidden__vVCRf"};